export const defaultState = {
  remoteMemberAssociation: null,
  memberAssociation: null,
  levelDomain: null,
  validFrom: null,
  validTo: null,
  status: null,
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
